<div *ngIf="isReady">
  <app-navbar></app-navbar>
  <div class="root-container">
    <router-outlet></router-outlet>
  </div>

  <app-snack-bar></app-snack-bar>
</div>

